import React, { Component } from 'react'
import './MemoryBank.less'
import { appMethod as app } from '@utils/app';
import { Toast,Modal,Button } from 'antd-mobile';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import FileList from '../FileList/FileList';
import { ajax } from '@utils/http';

const fileIcons = {
  pdf: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term7.png',
  doc: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term8.png',
  ppt: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term9.png',
  txt: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term10.png',
  excel: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term11.png',
 }


export default class MemoryBank extends Component {
  state = {
    tabStatus: '1',
    tabFileStatus:'0',
    flieList:[],
    longList:[],
    isMore: '',
    currentPage: 1,
    searchValue:'',
    fileDialogShow:false,
    hiddenmodalput:false,
    inputText:'',
    editIds:''
  }
  constructor(props) {
    super(props);
    this.GetUserFile(this.state.currentPage)
  }

  componentDidMount(){
  }

  cancel= () => {
    this.props.cancelDialog('memoryDialog');
  }
  // 获取用户文件列表
  GetUserFile = (page)=>{
    app.showLoading({
      title: '加载中..',
    })
    app.sendRequest({
      url: '/index.php?r=ChatAI/GetUserFile',
      data: {
        app_id: app.getAppId(),
        session_key: '',
        role_id:-1,
        type: Number(this.state.tabFileStatus),
        file_name:this.state.searchValue,
        page: page || 1,
        page_size: 8
      },
      hideLoading: true,
      method: 'POST',
      success:(res) => {
        if(res.status == 0){
          app.hideLoading();
          this.setState({
            flieList:res.data,
            searchValue:'',
            isMore: res.is_more,
            currentPage: res.current_page || '1',
          })
        }
      }
    })
  }

  // 取消
  cancelDialog = ()=>{
    this.setState({
      fileDialogShow: false
    })
  }
  // 确认
  comfirmDialog = ()=>{
    this.GetUserFile(this.state.currentPage)
    this.setState({
      fileDialogShow: false
    })
  }
  // 记忆tab切换
  checkTap = event => {
    let type = event.currentTarget.dataset.type;
    this.setState({
      tabStatus: type,
      currentPage:1,
      isMore:''
    },()=>{
      const {tabStatus,currentPage} = this.state
      if(tabStatus === '1'){
        this.setState({
          longList:[]
        })
        this.GetUserFile(currentPage)
      }else{
        this.setState({
          flieList:[]
        })
        this.UserMemory(currentPage,'add')
      }
    })
  }

  // 文件类型tab切换
  checkFile = event => {
    let type = event.currentTarget.dataset.type;
    this.setState({
      tabFileStatus: type,
      flieList:[]
    },()=>{
      this.GetUserFile(this.state.currentPage)
    })
  }

  nextPage = () => {
    const {tabStatus} = this.state;
    if(this.state.isMore != 1){
      Toast.info('已经是最后一页了')
      return
    }
    let page = this.state.currentPage + 1;
    if(tabStatus === '1'){
      this.GetUserFile(page) 
    }else{
      this.UserMemory(page,'add')
    }
  }

  prePage = () => {
    const {tabStatus} = this.state;
    if(this.state.currentPage == 1){
      Toast.info('已经是第一页了')
      return
    }
    let page = this.state.currentPage > 2 ? this.state.currentPage - 1:1
    if(tabStatus === '1'){
      this.GetUserFile(page)
    }else{
      this.UserMemory(page,'add')
    }
  }


  bindSearInput = (event) => {
    let val = event.target.value;
    this.setState({
      searchValue: val
    })
  }
    // 处理按下Enter键的事件
    handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        this.GetUserFile(this.state.currentPage)
      }
    };

    // 文件上传弹窗
    fileUpload = ()=>{
      this.setState({
        fileDialogShow:true
      })
    }

    // 删除文件
    deleteFile = (ids,status)=>{
       let confirmationMessage = '';
       if (status == '0') {
        confirmationMessage = '确定要删除该图片吗?';
      } else if (status == '1') {
        confirmationMessage = '确定要删除该文件吗?';
      }
      let idsArray = [ids]
      const jsonString = JSON.stringify(idsArray);
       app.showModal({
        content: confirmationMessage,
        showCancel: true,
        confirmColor: '#437eff',
        cancelColor: '#437eff',
        confirm: () => {
          app.sendRequest({
            url: '/index.php?r=ChatAI/DelUserFile',
            data: {
              ids:jsonString
            },
            method: 'POST',
            success:(res) => {
              if(res.status == 0){
                Toast.info('删除成功');
                if (this.state.flieList.length === 1) {
                    if(this.state.currentPage > 1) {
                      this.GetUserFile(this.state.currentPage - 1);
                    }else{
                      this.GetUserFile(this.state.currentPage)
                    }
                 } 
                else {
                  // 否则重新获取当前页面的数据
                  this.GetUserFile(this.state.currentPage);
                }
              }else{
                Toast.fail('删除失败');
              }
            }
          })
        },
      })
       
    }

    // 删除长期记忆
    deleteLongterm = (ids)=>{
      let idsArray = [ids]
      const jsonString = JSON.stringify(idsArray);
      app.showModal({
        content: '你确定要删除该条长期记忆吗?',
        showCancel: true,
        confirmColor: '#437eff',
        cancelColor: '#437eff',
        confirm: () => {
          ajax({
            url: '/index.php?r=ChatAI/UserMemory'+'&ids=' + jsonString,
            type:'Delete',
            success: (res) => {
              if (res.status === 0) {
                let totalLength = 0;
                  for (let year in this.state.longList) {
                    if (this.state.longList.hasOwnProperty(year)) {
                      totalLength += this.state.longList[year].length; // 累加每个年份数组的长度
                    }
                  }
                  if (totalLength === 1) {
                  if(this.state.currentPage > 1) {
                    setTimeout(() => {
                      Toast.info('删除成功');
                      this.UserMemory(this.state.currentPage - 1,'add');
                    }, 500);
                  }else{
                    setTimeout(() => {
                      Toast.info('删除成功');
                      this.UserMemory(this.state.currentPage,'add',)
                    }, 500);
                  }
                  } else{
                    setTimeout(() => {
                      Toast.info('删除成功');
                      this.UserMemory(this.state.currentPage,'add',)
                    }, 500);
                }
              }               
            }
          });
        },
      })
    }

    searchClick = ()=>{
      this.GetUserFile()
    }

    useFile = (items)=>{
      this.props.useComfirmFile(items)
    }

    // 长期记忆文件
    UserMemory = (page,status)=>{
      let metheds,memorys
      let pages;
      let pageSize;
      let edits;
      let structString;
      if(status === 'add'){
        metheds = 'GET'
        pages = page || 1;
        pageSize = 10
      }else if(status === 'edit'){
         metheds = 'POST'
         memorys = this.state.inputText
         edits = this.state.editIds
         const struct = [
          {
            _id:edits,
            memory:memorys
          }
         ]
         structString = JSON.stringify(struct)
      }
      app.sendRequest({
        url: '/index.php?r=ChatAI/UserMemory',
        data: {
          app_id: app.getAppId(),
          session_key: '',
          page: pages,
          page_size: pageSize,
          struct:structString,
        },
        hideLoading: true,
        method: metheds,
        success:(res) => {
          if(res.status == 0){
           if(status === 'add'){
            const totalPages = Math.ceil(res.data.count / pageSize);
            const isMore = page < totalPages ? 1 : 0;
            const newData = this.groupByDate(res.data.data)
           
              this.setState({
                longList:newData,
                currentPage:page,
                isMore: isMore
             })   
           }else if(status === 'edit'){
            setTimeout(() => {
              this.UserMemory(this.state.currentPage, 'add');
              Toast.info('修改成功');
            }, 500);
            // this.UserMemory(this.state.currentPage,'add')
           }
          }
        }
      })
    }

    // 按日期分组
  groupByDate = (data) => {
    return data.reduce((acc, item) => {
      const date = item.date.split(' ')[0];  // 获取日期部分
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(item);
      return acc;
    }, {});
  };

  // 关闭编辑弹窗
  canceledits = () => {
    this.setState({ hiddenmodalput: false})
  }

  // 确认弹窗
  confirm = ()=>{
    this.setState({ hiddenmodalput: false})
    this.UserMemory(this.state.currentPage,'edit')
  }

  // 编辑长期记忆
  editLongterm = (contents,ids) =>{
    this.setState({ hiddenmodalput: true,inputText:contents,editIds:ids})
  }

  handleInputChange = (event) => {
    this.setState({
      inputText: event.target.value,  // 更新状态为文本框中的值
    });
  }

  render() {
    let { tabStatus,tabFileStatus,searchValue,fileDialogShow,longList,hiddenmodalput,inputText } = this.state;
    
    return (
      <div className="memnoryBankDialog">
          <div className='mask' onClick={this.cancel}></div>
          <div className='content'>
            <label className='ico-moon icon-closes closes_btn' onClick={this.cancel}></label>
            {/* <div className='title'>记忆库</div> */}
              <div className='tab_line'>
                {<div className={tabStatus=='1'?'active':''} onClick={this.checkTap} data-type='1'>文件记忆</div>}
                {<div className={tabStatus=='2'?'active':''} onClick={this.checkTap} data-type='2'>长期记忆</div>}
              </div> 
           {
            tabStatus=='1'&&<div className='file_box'>
              <div className="file_hd">
                <div className='file_tab'>
                  <div className={tabFileStatus == '0' ? 'active' : ''} onClick={this.checkFile} data-type='0'>照片</div>
                  <div className={tabFileStatus == '1' ? 'active' : ''} onClick={this.checkFile} data-type='1'>文件</div>
                </div>
                <div className="file_upload">
                    <div className="file_ipt">
                      <div className="file_icon" onClick={this.searchClick}><label className='ico-moon icon-search'></label></div>
                      <input 
                        type="text" 
                        value={searchValue} 
                        placeholder="请输入关键字" 
                        onChange={this.bindSearInput}
                        onKeyDown={this.handleKeyDown}
                      />
                    </div>
                    <div className="file_btn" onClick={this.fileUpload}>
                      <span>上传</span>
                    </div>
                </div>
              </div>  
               {
                tabFileStatus == '0' && <div className="file_contetnt">
                  <div className="file_list">
                  {
                    this.state.flieList.map((item, index) => (
                      <div className="file_box_cnt" key={index}>
                        {/* <img src={item.file_url} alt="file" /> */}
                        <div className="file_img" style={{ backgroundImage: `url(${item.file_url})` }}>


                        </div>
                        <span className="img_name">{item.file_name}</span>
                        <div className="file_icon">
                          <span>{item.add_time}</span>
                          <div className='file_use'>
                          <Tooltip placement="top" overlay='使用' trigger={['hover']}>
                            <img onClick={()=> this.useFile(item)} src="https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term4.png" alt="tooltip-icon" />
                          </Tooltip>
                          </div>
                        </div>
                        <div className="file_close" onClick={()=>this.deleteFile(item.id,'0')}>
                          <img src="https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term5.png" alt="tooltip-icon" />
                        </div>
                      </div>
                    ))
                  }
                  {this.state.flieList.length == 0 && 
                      <div className='no_data'>
                        <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/undata.png" />
                        <div>暂无数据~</div>
                      </div>
                  }
                  </div>
                </div>
                }
                {
                tabFileStatus == '1' && <div className="file_contetnt">
                  <div className='main'>
                      <div className='tabel_head'>
                        <div>文件名称</div>
                        <div>文件大小</div>
                        <div>上传时间</div>
                        <div>操作</div>
                      </div>
                      {
                         this.state.flieList.map((item, index) => (
                          <div className='tabel_item' key={index}>
                            <div className="tabel_img">
                            {
                               fileIcons[item.file_type] && (
                                  <img
                                    className="icon_file"
                                    src={`${fileIcons[item.file_type]}`}
                                  />
                                )
                              }
                              <span>{item.file_name}</span>
                            </div>
                            <div>{item.file_size}</div>
                            <div>{item.add_time}</div>
                            <div className="tabel_opera">
                              <Tooltip placement="top" overlay='使用' trigger={['hover']}>
                                <img onClick={()=> this.useFile(item)} src="https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term4.png" alt="tooltip-icon" />
                              </Tooltip>
                              <Tooltip placement="top" overlay='删除' trigger={['hover']}>
                                <img onClick={()=>this.deleteFile(item.id,'1')} src="https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term6.png" alt="tooltip-icon" />
                              </Tooltip>
                            </div>
                          </div>    
                         ))
                      }
                      {this.state.flieList.length == 0 && 
                      <div className='no_data'>
                        <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/undata.png" />
                        <div>暂无数据~</div>
                      </div>
                      }
                  </div>
                </div>
                }
            </div>
           }
           {
            tabStatus=='2'&&<div className='longterm_box'>
                  {Object.keys(longList).map(date => (
                    <div key={date} className="longterm_list">
                      <span className="longterm_title">{date}</span>
                      {longList[date].map(item => (
                        <div key={item._id} className="longterm_item">
                          <span className="longterm_timer">{item.date.split(' ')[1].split(':')[0]}:{item.date.split(' ')[1].split(':')[1]}</span>
                          <span className="longterm_content">{item.content}</span>
                          <Tooltip placement="top" overlay="编辑" trigger={['hover']}>
                            <img onClick={()=>this.editLongterm(item.content,item._id)} src="https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term14.png" alt="tooltip-icon" />
                          </Tooltip>
                          <Tooltip placement="top" overlay="删除" trigger={['hover']}>
                            <img onClick={()=>this.deleteLongterm(item._id)} src="https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term6.png" alt="tooltip-icon" />
                          </Tooltip>
                        </div>
                      ))}
                    </div>
                  ))}
                  {this.state.longList.length == 0 && 
                      <div className='no_data'>
                        <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/undata.png" />
                        <div>暂无数据~</div>
                      </div>
                  }
              </div>
           }
             <div className='btn_box'>
              <label className='ico-moon icon-leftarrow' onClick={this.prePage}></label>
              <div className='btn_page'>{this.state.currentPage}</div>
              <label className='ico-moon icon-rightarrow' onClick={this.nextPage}></label>
            </div>
          </div>
          {/* 弹窗显示 */}
          <Modal
            className="modal-wrap"
            transparent
            title="编辑名称"
            visible={hiddenmodalput}
          >
           <div className="modal-content">
            <textarea
              className="input-textarea"
              value={inputText}  // 绑定文本框的值
              onChange={this.handleInputChange}  // 处理输入变化
              placeholder="请输入内容..."
            />
           </div>
            <div className="modal-btn-wrap">
              <div className="cancel" onClick={this.canceledits}>取消</div>
              <div className="confirm" onClick={this.confirm}>确认</div>
            </div>
          </Modal>

          {/* 列表组件 */}
          {fileDialogShow == true && <FileList cancelDialog={this.cancelDialog} comfirmDialog={this.comfirmDialog} />}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/chatgpt-page/component/MemoryBank/MemoryBank.jsx